import { canCreateOrEditCRM } from "./crm-permissions";
import { formatDate } from "./format";

export function isLeadConverted(lead) {
  return Boolean(lead?.converted_deal_id);
}

export function canConvertLead({ perm, lead }) {
  return canCreateOrEditCRM(perm) && !lead?.archived_at && !isLeadConverted(lead);
}

export function getLeadConversionDateLabel(convertedAt) {
  if (!convertedAt) return "";
  return `Umgewandelt am ${formatDate(convertedAt)}`;
}
